<template>
  <div>
    <nav-bar />
    <v-container fluid v-if="!loadingStalled">
      <v-row>
        <v-col cols="12">
          <v-card :loading="loading">
            <v-tabs show-arrows>
              <v-tab>Overview</v-tab>
              <!-- <v-tab>Update Profile</v-tab>
            <v-tab v-if="device.type === 'ecotron'">Remote On-Off</v-tab>
            <v-tab>Change Password</v-tab> -->
              <v-tabs-slider></v-tabs-slider>
              <v-tab-item>
                <v-container fluid>
                  <v-row justify="space-between">
                    <v-col cols="12" sm="12" md="6">
                      <v-card outlined height="500">
                        <v-card-title class="title font-weight-bold">
                          System Information
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-container>
                          <v-row
                            justify="space-between"
                            v-for="(value, name) in overview.machine"
                            :key="name"
                          >
                            <v-col cols="6">
                              <span class="font-weight-bold">{{ name }} :</span>
                            </v-col>
                            <v-col cols="6">{{ value }}</v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                      <v-card outlined height="500">
                        <v-card-title class="title font-weight-bold">
                          Location
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-container>
                          <gmap-map
                            :center="{ lat: 22, lng: 80 }"
                            :zoom="4"
                            style="width: 100%; height: 400px"
                          >
                            <gmap-marker :position="overview.location" />
                          </gmap-map>
                        </v-container>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-card outlined>
                        <v-card-title class="title font-weight-bold">
                          User Information
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-container>
                          <v-row
                            justify="space-between"
                            v-for="(value, name) in overview.user"
                            :key="name"
                          >
                            <v-col cols="6">
                              <span class="font-weight-bold">{{ name }} :</span>
                            </v-col>
                            <v-col cols="6">{{ value }}</v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
              <!-- <v-tab-item>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-card outlined="">
                      <v-card-title class="title font-weight-bold">
                        Update Profile</v-card-title
                      >
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-form></v-form>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item v-if="device.type === 'ecotron'">
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-card outlined="">
                      <v-card-title class="title font-weight-bold">
                        Remote On-Off
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-form></v-form>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-title class="title font-weight-bold">
                        Change Password
                      </v-card-title>

                      <v-divider></v-divider>
                      <v-card-text>
                        <v-form>
                          <v-text-field
                            label="New Passord"
                            prepend-icon="mdi-lock"
                            type="password"
                            v-model="newPassword"
                            :rules="rules"
                          />

                          <v-text-field
                            label="Confirm Password"
                            prepend-icon="mdi-lock"
                            type="password"
                            v-model="confirmPassword"
                            :rules="rules"
                          />
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" @click="changePassword"
                          >Change Passowrd</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item> -->
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { nodeRestApi } from '../plugins/api';
import NavBar from '../components/NavBar';
export default {
  name: 'device-profile',
  components: {
    NavBar
  },
  data() {
    return {
      device: {},
      overview: {},
      updateMachine: {},
      loading: false,
      loadingStalled: false,
      newPassword: '',
      confirmPassword: '',
      rules: [value => !!value || 'Required']
    };
  },
  methods: {
    async changePassword() {
      alert('Yet to be implemented');
    }
  },
  async created() {
    this.loading = true;
    let route = this.$route.name;
    await this.$store.commit('setError', false);
    if (route.includes('ecotron')) {
      this.device = { type: 'ecotron', id: this.$route.params.topic };
    } else if (route.includes('ecofrost')) {
      this.device = { type: 'ecofrost', id: this.$route.params.topic };
    } else {
      this.device = null;
    }
    try {
      const response = await nodeRestApi.get(
        `${this.device.type}/profile/${this.device.id}`
      );
      this.overview = response.data.overview;
      this.updateMachine = response.data.updateMachine;
      this.loading = false;
    } catch (error) {
      this.loadingStalled = true;
      this.loading = false;
      if (error.response.data.error.message) {
        this.$store.commit('setError', error.response.data.error.message);
      } else {
        this.$store.commit('setError', error.response.data.error);
      }
    }
  }
};
</script>

<style></style>
